import React from 'react';

const TulKanatSettings = React.memo(({
  extraPrices,
  setExtraPrices,
  handleSaveSettings,
  isSavingSettings
}) => {
  return (
    <div className="settings-card" style={{ marginBottom: '20px' }}>
      <div className="settings-card-title">
        <i className="fas fa-cut"></i>
        <h4>Pile Ek Ücret Ayarları (₺)</h4>
        <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
          {isSavingSettings ? '...' : 'Kaydet'}
        </button>
      </div>
      <div className="settings-grid">
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>S Pile</label>
          <input type="number" value={extraPrices.sPile} onChange={(e) => setExtraPrices(p => ({ ...p, sPile: e.target.value }))} />
        </div>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>Amerikan 2'li</label>
          <input type="number" value={extraPrices.american2} onChange={(e) => setExtraPrices(p => ({ ...p, american2: e.target.value }))} />
        </div>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label>Amerikan 3'lü</label>
          <input type="number" value={extraPrices.american3} onChange={(e) => setExtraPrices(p => ({ ...p, american3: e.target.value }))} />
        </div>
      </div>
    </div>
  );
});

export default TulKanatSettings;
